exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pydantic-schema-generator {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 120px;\n  height: calc(100vh - 200px);\n  margin-left: 40px;\n  margin-right: 40px;\n}\n", ""]);

// exports
